// Centralized provider mapping and resolution helpers

// Union of all provider codes/names seen across GameCard and GameSearch
export const PROVIDER_NAMES = {
  // From GameCard
  swtp: "Sweet Spot",
  bbl: "Live88",
  ont: "OneTouch",
  hsg: "Hacksaw Gaming",
  pls: "Playson",
  clt: "Caleta Gaming",
  ela: "ElaGames",
  evo: "Evolution Gaming",
  avx: "AvatarUX",
  klb: "Kalamba Games",
  nlc: "Nolimit City",
  ppr: "Pragmatic Play",
  rlx: "Relax Gaming",
  nyx: "NYX Gaming",
  qks: "Quickspin",
  ygg: "Yggdrasil",
  btg: "Big Time Gaming",
  elk: "ELK Studios",
  igt: "IGT",
  net: "NetEnt",
  red: "Red Tiger",
  wms: "WMS",
  bsg: "Booming Games",
  gam: "Gamomat",

  // From GameSearch (including alternative codes mapping to same providers)
  ppt: "Pragmatic Play", // alt for ppr
  nlt: "NetEnt", // alt for net
  mgs: "Microgaming",
  ezg: "Ezugi",
  rel: "Relax Gaming", // alt for rlx
  nol: "Nolimit City", // alt for nlc
  psh: "Push Gaming",
  cal: "Caleta Gaming", // alt for clt
  ald: "Amatic",
  end: "Endorphina",
  ism: "iSoftBet",
  kag: "Kagaming",
  mrk: "Merkur Gaming",
  pgf: "PG Soft",
  pnk: "Pink Elephant",
  spb: "Spinberry",
  tom: "Tom Horn Gaming",
  waz: "Wazdan",
};

export function providerNameFromCode(code) {
  if (!code) return undefined;
  return PROVIDER_NAMES[code] || undefined;
}

// Resolve a canonical provider display name from a game object
export function resolveProviderName(game) {
  if (!game || typeof game !== "object") return "Unknown";

  // Try to detect a provider code from common fields
  const pCode = game.provider_code || game.providerCode || game.provider?.code;

  return (
    game.game_providers?.provider_name ||
    game.product ||
    (pCode ? PROVIDER_NAMES[pCode] : undefined) ||
    game.provider_name ||
    game.providerName ||
    game.provider?.provider_name ||
    pCode ||
    game.provider ||
    "Unknown"
  );
}
